import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '../../product/components/molecules/CustomTable'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '../../product/context/alert/alertContext'
import ProductContext from '../../product/context/product/productContext'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import CustomDialog from '../../product/components/organisms/Dialog'
import CommentContext from '@/product/context/comment/commentContext'
import * as Yup from 'yup'
import { mapData } from '@/product/common/components'
import ReplyComments from './ReplyComments'
import AuthContext from '@/product/context/auth/authContext'

const Comments = (props) => {
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)

    const { user } = useContext(AuthContext)

    const {
        all_comments,
        getAllComments,
        saveComment,
        responseStatus: replyCommentsResponse,
        clearResponse: clearComment,
    } = useContext(CommentContext)

    const history = useHistory()
    const { setAlert } = alertContext

    const data = props.data
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })
    const toggleFullScreenPopup = (popup, status, id, projectType) => {
        if (popup) {
            setManage({ popup, status, id, projectType })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_id: 0,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllComments(values)
        },
    })

    useEffect(() => {
        if (all_comments) {
            setTableBody(
                all_comments.records.length ? all_comments.records : []
            )
        }
        setIsLoading(false)
    }, [all_comments])

    const resetFrom = () => {
        formik.setValues({
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_id: 0,
        })
        formik.handleReset()
        setIsLoading(false)
    }

    useEffect(() => {
        if (data.status === 'question') {
            setTableBody([])
            setIsLoading(true)
            formik.values.page = 1
            formik.values.project_id = data?.id || 0
            getAllComments(formik.values)
        } else {
            resetFrom()
        }
    }, [data])

    const tableValues = [
        {
            field: 'comment',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Question',
        },
        {
            field: 'last_reply',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Answer',
        },
        {
            field: 'first_name',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'First Name',
        },
        {
            field: 'last_name',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Last Name',
        },
        // {
        //     field: 'email',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Email',
        // },
    ]

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'answer') {
            toggleFullScreenPopup(true, type, id)
        } else if (type === 'new_answer') {
            // setCommentId(id)
            formikAddComment.values.comment_id = id
            formikAddComment.values.project_id = secondaryID
            setAddCommentPopup(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            buttonType: 'quiz',
            clickType: 'answer',
            clickID: 'id',
            secondaryClickID: 'project_id',
            onclick: onClickEdit,
            tooltipTitle: 'Answers History',
        })
        actionPush.push({
            buttonType: 'add',
            clickType: 'new_answer',
            clickID: 'id',
            secondaryClickID: 'project_id',
            onclick: onClickEdit,
            tooltipTitle: 'Add a Answer',
        })

        return actionPush
    }

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'id',
        secondaryClickID: 'project_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const [addCommentPopup, setAddCommentPopup] = useState(false)
    const changeAddCommentPopup = () => {
        setAddCommentPopup(!addCommentPopup)
    }

    const validationAddComment = Yup.object({
        comment: Yup.string().required('Required'),
    })
    const formikAddComment = useFormik({
        initialValues: {
            table: '',
            comment: '',
            comment_id: 0,
            user_id: 0,
            project_id: 0,
        },
        validationSchema: validationAddComment,
        onSubmit: (values) => {
            formikAddComment.setSubmitting(true)
            if (values.comment !== '') {
                formikAddComment.values.table = 'comments'
                formikAddComment.values.user_id = user?.admin_id || 0

                saveComment(values)
            }
        },
    })

    useEffect(() => {
        if (
            replyCommentsResponse?.from === 'saveComment' &&
            replyCommentsResponse?.status === 'success'
        ) {
            // setAlert('Commented Successfully', replyCommentsResponse.status)
            clearComment()
            formikAddComment.values.comment = ''
            setAddCommentPopup(false)
            setIsLoading(true)
            formik.values.page = 1
            formik.values.project_id = data?.id || 0
            getAllComments(formik.values)
        }
    }, [replyCommentsResponse])

    const addCommentoption = [
        {
            label: 'Answer',
            placeholder: 'Add a Answer',
            type: 'textarea',
            class: 'col-12',
            name: 'comment',
            formik: formikAddComment,
        },
    ]

    const closeFunction = () => {
        setAddCommentPopup(false)
        formikAddComment.values.comment = ''
    }

    return (
        <>
            <FullScreenPopup
                modaltitle={`Question & Answers`}
                open={data.status === 'question' ? data.popup : false}
                handleClose={() => props.function(false)}
            >
                <div className="addUserModal">
                    <div className="fspBody">
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={all_comments}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllComments}
                            hideCompactView={true}
                            columnStorageVariable={'table_manage_comments'}
                        />
                    </div>
                </div>
            </FullScreenPopup>
            <CustomDialog
                title={'Answer'}
                open={addCommentPopup}
                function={changeAddCommentPopup}
                disableBackdropClick
                className="commentsModal"
            >
                <p>{'Write an answer for this question'}</p>

                <div className="row">
                    {Object.values(mapData(addCommentoption))}
                </div>

                <div className="actionWrapper">
                    <Button id="comment_cancel" onClick={() => closeFunction()}>
                        {'Cancel'}
                    </Button>
                    <PrimaryButton
                        id="comment_submit"
                        onClick={formikAddComment.handleSubmit}
                        type="button"
                        label={'Submit'}
                    />
                </div>
            </CustomDialog>
            <ReplyComments data={manage} function={toggleFullScreenPopup} />
        </>
    )
}

export default Comments
